function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 27.6472,
  cy: 27.7346,
  r: 26.8676,
  fill: "#E91515"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9139 19.1822H20.8019V35.9822H16.9139V19.1822ZM32.0609 19.1822C33.5489 19.1822 34.8369 19.4302 35.9249 19.9262C37.0289 20.4222 37.8769 21.1262 38.4689 22.0382C39.0609 22.9502 39.3569 24.0302 39.3569 25.2782C39.3569 26.5102 39.0609 27.5902 38.4689 28.5182C37.8769 29.4302 37.0289 30.1342 35.9249 30.6302C34.8369 31.1102 33.5489 31.3502 32.0609 31.3502H28.6769V35.9822H24.7889V19.1822H32.0609ZM31.8449 28.1822C33.0129 28.1822 33.9009 27.9342 34.5089 27.4382C35.1169 26.9262 35.4209 26.2062 35.4209 25.2782C35.4209 24.3342 35.1169 23.6142 34.5089 23.1182C33.9009 22.6062 33.0129 22.3502 31.8449 22.3502H28.6769V28.1822H31.8449Z",
  fill: "white"
});

function SvgInstantPot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstantPot);
export default __webpack_public_path__ + "static/media/instant-pot.e76b461a.svg";
export { ForwardRef as ReactComponent };